/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable max-len */
import { Dialog } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContractStatus } from '@ffd/api-client';
import { TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { LicenseAgreementFormComponent } from '../../license-agreement-form';
import { SiteSetupComponentService } from '../../site-setup/site-setup.component.service';

@Component({
  selector: 'lib-external-sign-form',
  imports: [CommonModule, SvgIconComponent, TranslateModule, LicenseAgreementFormComponent, TooltipModule],
  templateUrl: './external-sign-form.component.html',
  styleUrl: './external-sign-form.component.scss',
})
export class ExternalSignFormComponent {
  private readonly service = inject(SiteSetupComponentService);
  private readonly activatedRoute = inject(ActivatedRoute);

  public vm = this.service.viewModel;
  public ownerName = computed(() => `${this.vm().contract?.data?.signatoryFirstName} ${this.vm().contract?.data?.signatoryLastName}`);
  public ContractStatus = ContractStatus;

  private readonly dialog = inject(Dialog);
  public onSubmitLicenseAgreement(): void {
    this.service.submitExternalForm();
  }

  public onDownloadClick(): void {
    this.service.downloadSignedPdfExternal();
  }
  public onCloseClick(): void {
    window.close();
  }
}
